import React from 'react'
import qs from 'qs'
import redirect from '../../../components/redirect/redirect'
import message from '../../../components/message/message'
import { initializeFormValidation } from '../../../helpers/forms/form-validation'
import customRequest from '../../../helpers/customRequest'
import ClipLoader from 'react-spinners/ClipLoader'

class Transfer extends React.Component
{
    state = {
        students: [],
        loading: false
    }
    componentDidMount()
    {
        var params = qs.parse(this.props.location.search, { ignoreQueryPrefix: true })
        if (!params.students) {
            redirect.send("/students", () => {
                message.error("Please select a student to be transfered.")
            })
            return
        }

        this.setState({students: params.students})
        initializeFormValidation(this.onSubmit)
    }
    
    onSubmit = () => {
        this.setState({loading: true}, () => {
            customRequest.post('/api/students/transfer/send', {
                students: this.state.students,
                email: document.getElementById('email-address').value
            })
            .then((response) => {
                this.setState({loading: false})
                var data = response.data
                message.clear()
                if (data.valid) {
                    redirect.send("/students")
                    message.success("Your student transfer has been successfully completed. Please ask the recipient to check their email for a transfer request.")
                } else {
                    message.error(data.message)
                }
            })
        })
    }

    render()
    {
        var { students } = this.state
        return (
            <React.Fragment>
                <h1>Transfer Student{students.length > 1 ? "s" : ""}</h1>
                <div class = "row subheader-text">
                    <div class = "col-sm-10 offset-sm-1 col-md-8 offset-md-2">
                        <p>Please enter the username of the person to whom you wish to transfer students.</p>
                        
                        <p>Please note that transferring a student is <strong>permanent</strong>, and will result in the student and all of their records being removed from your account and added to the other user's.</p>
                    </div>
                </div>

                <form class = "form-horizontal form-validate" noValidate method = "post">
                    <div class = "form-group row">
                        <label class = "text-center-xs bold-xs col-sm-3 control-label text-right">Student{students.length > 1 ? "s" : ""}</label>
                        
                        <div class = "col-sm-6">
                        {
                            students.map((student) =>
                            {
                                return <p class = "form-control-static text-left text-center-xs break-words">{student}</p>
                            })
                        }
                        </div>
                    </div>
                    
                    <div class = "form-group row">
                        <label for = "username" class = "d-none d-sm-inline col-sm-3 control-label text-right">Email Address</label>
                        
                        <div class = "col-sm-6">
                            <input type = "text" disabled={this.state.loading} class = "form-control" id = "email-address" name = "email-address" placeholder = "Email Address" required autofocus data-description = "enter an email address" />
                        </div>
                    </div>
                    
                    <button type = "submit"  disabled={this.state.loading} class = "btn btn-secondary btn-lg">{this.state.loading ?
                    <ClipLoader
							size={20}
							color={"#123abc"}
							loading={this.state.loading}
							/> : "Transfer"}</button>
                </form>
            </React.Fragment>
        )
    }
}

export default Transfer
